/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolFavoriteIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-favorite"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 20.95Q12 20.95 11.75 20.95Q11.5 20.95 11.04 20.77Q10.57 20.6 10.2 20.25L8.1 18.32Q5.58 16 3.39 13.55Q1.2 11.1 1.2 7.95Q1.2 5.3 3 3.52Q4.8 1.75 7.45 1.75Q8.93 1.75 10.1 2.35Q11.28 2.95 12 3.6Q12.72 2.95 13.9 2.35Q15.07 1.75 16.55 1.75Q19.2 1.75 21 3.52Q22.8 5.3 22.8 7.95Q22.8 11.1 20.61 13.55Q18.43 16 15.93 18.3L13.8 20.25Q13.43 20.6 12.96 20.77Q12.5 20.95 12 20.95Z" fill={color} />
    </svg>
  );
}
